export default "__VITE_ASSET__0793b7c3__"